export default __webpack_public_path__ + "static/GF-PREMIO-PE-2e0fc21443051459035840e7bf558720.png";